import { useQuery } from '@tanstack/react-query'
import { transferServices } from '../transferServices'
import { ExternalWithdrawCalcFeesPayload } from '../transferTypes'

export const useCalculateExternalWithdrawFee = (
  payload: ExternalWithdrawCalcFeesPayload,
) =>
  useQuery({
    queryKey: ['calculateExternalWithdrawFee', payload],
    queryFn: () => transferServices.calculateExternalWithdrawFee(payload),
    refetchInterval: 60 * 1000,
  })
